import { FC } from 'react';
import ShowGptSummaryHandler from '../Components/ExploreGpt/ShowGptSummaryHandler';

export const PageShowGptSummary: FC = () => {
    return <ShowGptSummaryHandler />;
};
